import {
	DrawerBody,
	Stack,
	Box,
	Flex,
	Image,
	Text,
	Button,
	useToast,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { Raider } from "../../../../types/raider";
import { nameCleanup } from "../../../../util/helpers";
import {
	getRewards,
	getRewardsToCollect,
} from "../../../../util/web3/interactQuests";

interface QuestProps {
	raider: Raider;
	questName: string;
	questIcon: string;
	rewardName: string;
	questString: string;
	timeTillHome: number;
}

export default function Returning(props: QuestProps) {
	const { raider, questName, questIcon, rewardName, questString } = props;
	const [rewardsToCollect, setRewardsToCollect] = useState<number>();

	const toast = useToast();

	useEffect(() => {
		const fetchData = async () => {
			setRewardsToCollect(
				await getRewardsToCollect(parseInt(raider.id), questString)
			);
		};

		fetchData();
	}, []);

	return (
		<DrawerBody>
			<Stack spacing="6" py="2" px="2">
				<Box background="#4a556878" borderRadius="md" px={4} py={8}>
					<Flex mb="15px" justifyContent="left" alignItems="center">
						<Image
							src="https://storage.googleapis.com/crypto-raiders-assets/web/currencies/basicQuest.png"
							width="40px"
							height="40px"
							alt="quest"
						/>
						<Text textStyle="questStatusHeader">{questName}</Text>
					</Flex>
					<Text>{nameCleanup(raider.name)} made it home! </Text>
					<Flex mt="16px !important" mb="16px">
						<Text mr="15px">Earned: </Text>
						<Image
							src={questIcon}
							width="25px"
							height="25px"
							alt={rewardName}
							mr="2px"
						/>
						<Text mr="15px">
							+{rewardsToCollect} {rewardName}
						</Text>

						<Image
							src="https://storage.googleapis.com/crypto-raiders-assets/web/currencies/herbalism.png"
							width="25px"
							height="25px"
							alt={rewardName}
							mr="2px"
						/>
						{rewardsToCollect != undefined && (
							<Text>+{rewardsToCollect * 10} Herbalism XP</Text>
						)}
					</Flex>
					{questString && (
						<Button
							onClick={() =>
								getRewards(parseInt(raider.id), questString, toast)
							}
						>
							Collect Rewards
						</Button>
					)}
				</Box>
			</Stack>
		</DrawerBody>
	);
}
